module.exports = __webpack_public_path__ + "static/media/photo.2199e0f5.jpg";